// extracted by mini-css-extract-plugin
export var banner = "_j2-0";
export var closeButton = "_j2-2";
export var greenCheckmark = "_j2-3";
export var hereLink = "_j2-4";
export var titleIcon = "_j2-1";